import { ActiveTournamentPlan } from 'modules/organizer/domain/interfaces/active-tournament-plan';
import { baseApi } from 'shared/api/base-api';

const activeTournamentPlanQuery = `#graphql
  query ActiveTournamentPlan($tournamentId: Int!) {
    activeTournamentPlan(tournamentId: $tournamentId) {
      id
      name
      priceInMinorUnits
      period
    }
  }
`;

interface ActiveTournamentPlanResponseDto {
  activeTournamentPlan: ActiveTournamentPlan | null;
}

const organizerPlanApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getActiveTournamentPlan: build.query<ActiveTournamentPlan | null, { tournamentId: number }>({
      query: ({ tournamentId }) => ({
        query: activeTournamentPlanQuery,
        variables: { tournamentId },
      }),
      transformResponse: (raw: ActiveTournamentPlanResponseDto): ActiveTournamentPlan | null => raw.activeTournamentPlan,
    }),
  }),
  overrideExisting: false,
});

export const { useGetActiveTournamentPlanQuery } = organizerPlanApi;
